import Home from "./components/LandingPage/Home";
import Access from "./components/Auth/Access";
import DashboardContainer from "./views/Dashboard/DashboardContainer";
import SocialLogin from "./components/SocialLogin";
import Agreements from "./components/Auth/Agreements";
import Invite from "./components/Invite";
import Actions from "./components/Actions";
import Quiz from "./views/Quiz";
import Survey from "./views/Survey";
import Video from "./views/Video";
// import Question from "./components/Question";
import VerifyMobile from "./components/VerifyMobile";
import Profile from "./views/Profile";
// import Profiles from "./components/Profile";
import EditAddress from "./components/EditAddress";
import Catalog from "./components/Catalog";
import Reward from "./components/Reward";
import InsertCode from "./components/InsertCode";
import Leaderboard from "./components/Leaderboard";
import Settings from "./components/Settings";
import Banned from "./components/Banned";
import InfoPage from "./components/InfoPage";
import NotFoundPage from "./components/NotFoundPage";
import CompleteProfile from "./components/CompleteProfile";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store/store";
import Information from "./components/Information";
import NotificationList from "./components/rebuild/NotificationList";
import InstantwinRandom from "./views/InstantwinRandom";
import UploadPagePlay from "@/views/UploadPagePlay";
import _ from "lodash";
import IdpCallback from "@/views/IdpCallback";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "/",
      name: "index",
      component: Home,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Access
    },
    {
      path: "/access",
      name: "access",
      component: Access
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: DashboardContainer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/dashboard/notifications",
      name: "dashboard",
      component: NotificationList,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/socialLogin/:provider",
      name: "socialLogin",
      component: SocialLogin
    },
    {
      path: "/agreements",
      name: "agreements",
      component: Agreements,
      meta: {
        requiresAuth: true,
        blockNotifications: true
      }
    },
    {
      path: "/invite",
      name: "invite",
      component: Invite,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/actions",
      name: "actions",
      component: Actions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/survey/:surveyId",
      name: "survey",
      component: Survey,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/prediction/:surveyId",
      name: "prediction",
      component: Survey,
      meta: {
        requiresAuth: true,
        prediction: true
      }
    },
    {
      path: "/instantwinRandom/:id",
      name: "instantwinRandom",
      component: InstantwinRandom,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/information/:informationId",
      name: "information",
      component: Information,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/instantwin/:instantwinId",
      name: "instantwin",
      component: Quiz,
      meta: {
        requiresAuth: true,
        blockNotifications: true
      }
    },
    // {
    //   path: "/question/:questionId",
    //   name: "question",
    //   component: Question,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/verify/mobile",
      name: "verifyMobile",
      component: VerifyMobile,
      meta: {
        requiresAuth: true,
        blockNotifications: true
      }
    },
    {
      path: "/settings/profile",
      name: "profileSettings",
      component: Profile,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: "/settings/profiles",
    //   name: "profileSettingsaa",
    //   component: Profiles,
    //   props: true,
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/settings/contact/edit",
      name: "editAddress",
      component: EditAddress,
      meta: {
        requiresAuth: true,
        blockNotifications: true
      },
      props: true
    },
    {
      path: "/catalog",
      name: "catalog",
      component: Catalog,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/catalog/rewards/",
      name: "reward",
      component: Reward,
      meta: {
        requiresAuth: true
      },
      props: true
    },
    {
      path: "/video/:videoId",
      name: "video",
      component: Video,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/code",
      name: "insert-code",
      component: InsertCode,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/leaderboard",
      name: "leaderboard",
      component: Leaderboard,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/settings",
      name: "settings",
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/banned",
      name: "banned",
      component: Banned,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/info/:page",
      name: "info",
      component: InfoPage
    },
    {
      path: "/complete-profile",
      name: "complete-profile",
      component: CompleteProfile,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/upload/:id",
      name: "upload",
      component: UploadPagePlay,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/idp/callback",
      name: "idp-callback",
      component: IdpCallback
    },
    {
      path: "*",
      name: "404",
      component: NotFoundPage
    }
  ],
  mode: "history"
});

router.beforeEach(async (to, from, next) => {
  try {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.state.user === undefined && !store.state.unavailableUserState) {
        console.log("prendo user");

        await store.dispatch("getUserInfo");
      }
      if (
        !store.state.unavailableUserState &&
        store.state.user.banned &&
        to.path !== "/banned"
      ) {
        router.replace("/banned");
        return;
      }

      if (store.state.unavailableUserState && to.path !== "/complete-profile") {
        router.push({
          path: "/"
        });
        return;
      }

      if (!to.matched.some(record => record.meta.blockNotifications)) {
        store.dispatch("getUnreadMessages");
      }

      if (store.getters.isLoggedIn) {
        if (!store.getters.getUser.profile.first_name) {
          await store.dispatch("getUserProfile");
        }

        const notComplete = _.isEmpty(
          _.trim(store.getters.getUser.profile.first_name)
        );

        if (notComplete && to.path !== "/agreements") {
          console.log("isLoggedIn notComplete");
          next("/");
          return;
        }

        console.log("isLoggedIn next");
        next();
        return;
      }
      console.log("not isLoggedIn");
      next("/");
    } else if (to.matched.some(record => record.meta.requiresGuest)) {
      if (store.getters.isLoggedIn) {
        if (!store.getters.getUser.profile.first_name) {
          await store.dispatch("getUserProfile");
        }

        console.log("getUser", store.getters.getUser);

        const notComplete = _.isEmpty(
          _.trim(store.getters.getUser.profile.first_name)
        );
        if (notComplete && to.path !== "/agreements") {
          console.log("dashboard notComplete");
          next("/");
          return;
        }
        console.log("dashboard complete");
        next("/dashboard");
        return;
      }
      console.log("dashboard not isLoggedIn");
      next();
    } else {
      console.log("else");
      next();
    }
    console.log("next");
    next();
  } catch (e) {
    console.error(e);
    await store.dispatch("logout");
    next();
  }
});

export default router;
